const urlUtils = {};

urlUtils.getQueryParam = (search, param) => {
  const params = new URLSearchParams(search);
  const value = params.get(param) || undefined;
  return value;
};

export default urlUtils;
